import { useEffect } from "react";
import { useI18n } from "../i18n.jsx";
import { usePlus } from "../plus/PlusProvider.jsx";

export default function PlusUpgradeModal({
  open,
  onClose,
  source = "plus-modal",
  title = null,
  copy = null
}) {
  const plus = usePlus();
  const { t } = useI18n();
  const monthly = plus.plusPlans.monthly;
  const yearly = plus.plusPlans.yearly;
  const showRenewal = plus.canRenewPlus;
  const showPlanOptions = !plus.isPlus || showRenewal;
  const activeCopy = showRenewal
    ? plus.currentPeriodEndLabel
      ? t("plus.modalCanceledUntil", { date: plus.currentPeriodEndLabel })
      : t("plus.modalCanceledCopy")
    : t("plus.activeCopy");
  const upgradeTitle = title || t("plus.upgradeTitle");
  const upgradeCopy = copy || t("plus.modalCopy");

  useEffect(() => {
    if (!open) return undefined;

    function handleKeydown(event) {
      if (event.key === "Escape") onClose();
    }

    window.addEventListener("keydown", handleKeydown);
    return () => window.removeEventListener("keydown", handleKeydown);
  }, [onClose, open]);

  if (!open) return null;

  return (
    <div className="plus-upgrade-backdrop" role="presentation" onMouseDown={onClose}>
      <section
        className="plus-upgrade-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="plus-upgrade-title"
        onMouseDown={(event) => event.stopPropagation()}
      >
        <p className="kicker">SielpA Plus</p>
        <h2 id="plus-upgrade-title">{showRenewal ? t("plus.renewTitle") : plus.isPlus ? t("plus.activeTitle") : upgradeTitle}</h2>
        <p>{plus.isPlus ? activeCopy : upgradeCopy}</p>
        <ul className="plus-upgrade-feature-list">
          <li>{t("plus.featurePremiumVoice")}</li>
          <li>{t("plus.featureVocabBurst")}</li>
          <li>{t("plus.featureNoAds")}</li>
        </ul>
        {plus.billingError ? <p className="plus-status-message is-error" role="alert">{plus.billingError}</p> : null}
        {plus.billingNotice ? <p className="plus-status-message" role="status">{plus.billingNotice}</p> : null}
        <div className="plus-upgrade-actions">
          <button className="secondary-button" type="button" onClick={onClose}>
            {t("plus.maybeLater")}
          </button>
          {!showPlanOptions ? (
            <button className="primary-button" type="button" disabled={plus.billingBusy} onClick={() => plus.openCustomerPortal({ source })}>
              {plus.billingBusy ? t("plus.opening") : t("plus.manage")}
            </button>
          ) : (
            <>
              <button className="primary-button" type="button" disabled={plus.billingBusy} onClick={() => plus.startCheckout("monthly", { source })}>
                {plus.billingBusy ? t("plus.opening") : `${showRenewal ? t("plus.renewPrefix") : ""}${monthly.label} - ${monthly.price}`}
              </button>
              <button className="secondary-button" type="button" disabled={plus.billingBusy} onClick={() => plus.startCheckout("yearly", { source })}>
                {`${showRenewal ? t("plus.renewPrefix") : ""}${yearly.label} - ${yearly.price}`}
              </button>
            </>
          )}
        </div>
      </section>
    </div>
  );
}
